import styled from 'styled-components';

const NavigationWrapper = styled.ul`
  margin: 0;
  padding-left: 27.5px;
  border-bottom: solid 1px ${props => props.theme.color.border};
  li {
    display: inline-block;
  }
`;

const Item = styled.div`
  cursor: pointer;
  font-weight: ${props => props.isActive && 500};
  display: inline-block;
  padding: 23px 2.5px;
  margin-right: 37.5px;
  border-bottom: ${props => props.isActive && `solid 2px ${props.theme.color.primary}`};
  color: ${props => props.isActive && props.theme.color.primary};
`;

export { NavigationWrapper, Item };
